export function getPercentage(initialValue: number, newValue: number) {
  const percentage = ((initialValue - newValue) * 100) / initialValue
  return { value: Math.floor(Math.abs(percentage)), sign: percentage > 0 ? ("+" as const) : ("-" as const) }
}
